const sign_in_experiences = {
    empty_content_url_of_terms_of_use: '你啟用了「使用條款」，請加入使用條款 URL。',
    empty_social_connectors: '你啟用了社交登錄的方式。請至少選擇一個社交連接器。',
    enabled_connector_not_found: '未找到已啟用的 {{type}} 連接器',
    not_one_and_only_one_primary_sign_in_method: '主要的登錄方式一定要有且只能有一個，請檢查你的輸入。',
    username_requires_password: '必須為用戶名註冊標識符啟用設置密碼。',
    passwordless_requires_verify: '必須為電郵/電話註冊標識符啟用驗證。',
    miss_sign_up_identifier_in_sign_in: '登錄方法一定要包含註冊標識符。',
    password_sign_in_must_be_enabled: '必須在註冊中要求設置密碼時啟用密碼登錄。',
    code_sign_in_must_be_enabled: '必須在註冊中不要求設置密碼時啟用驗證碼登錄。',
    unsupported_default_language: '{{language}} 無法選擇作為默認語言。',
    at_least_one_authentication_factor: '至少要選擇一個登錄要素',
    backup_code_cannot_be_enabled_alone: '備份代碼不能單獨啟用。',
    duplicated_mfa_factors: '檢測到重複的多因子驗證因素。',
    email_verification_code_cannot_be_used_for_mfa: '啟用電郵驗證登錄時，不能將電郵驗證碼用於多因子驗證。',
    phone_verification_code_cannot_be_used_for_mfa: '啟用 SMS 驗證登錄時，不能將 SMS 驗證碼用於多因子驗證。',
    email_verification_code_cannot_be_used_for_sign_in: '當啟用多因子驗證時，電子郵件驗證碼不能用於登錄。',
    phone_verification_code_cannot_be_used_for_sign_in: '當啟用多因子驗證時，SMS 驗證碼不能用於登錄。',
    adaptive_mfa_requires_mfa: '啟用自適應 MFA 前必須先啟用 MFA。',
    adaptive_mfa_requires_non_skippable_policy: '啟用自適應 MFA 需要一個無法跳過的 MFA 提示政策。請使用 PromptOnlyAtSignInMandatory 或 PromptAtSignInAndSignUpMandatory。',
    non_adaptive_mfa_requires_skippable_policy: '當自適應 MFA 被禁用時，MFA 提示政策必須可跳過。不要使用 PromptOnlyAtSignInMandatory 或 PromptAtSignInAndSignUpMandatory。',
    duplicated_sign_up_identifiers: '檢測到重複的註冊標識符。',
    missing_sign_up_identifiers: '主要的註冊標識符不能為空。',
    invalid_custom_email_blocklist_format: '無效的自定義電子郵件黑名單條目：{{items, list(type:conjunction)}}。每個條目必須是有效的電子郵件地址或電子郵件域，例如，foo@example.com 或 @example.com。',
    forgot_password_method_requires_connector: '忘記密碼方法需要配置相應的 {{method}} 連接器。',
    password_expiration_requires_forgot_password: '密碼過期需要至少配置一種帶有有效連接器的忘記密碼方式。',
    password_expiration_not_enabled: '密碼過期策略未啟用。在過期密碼前，請在登錄體驗設置中啟用它。',
    password_expiration_invalid_period_days: '啟用密碼到期策略時，有效期天數必須為正整數。',
    username_policy_case_conflicts_exist: '無法在用戶名僅因大小寫區分的情況下切換為不區分大小寫的用戶名。請解決衝突後重試。',
};
export default Object.freeze(sign_in_experiences);
